var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-view"},[_c('div',{staticClass:"terms-view__wrapper mv-32"},[(_vm.booking)?_c('Section',{attrs:{"limiter":""}},[_c('div',{staticClass:"grid-hd-8",domProps:{"innerHTML":_vm._s(_vm.booking)}})]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }